import { Component, Vue } from 'vue-property-decorator';
import moment from 'moment';
import { changeNumberFormat } from '@/assets/common/services'

@Component({
    filters: {
        changeNumberFormat
    }
})

export default class IncomeAndOutgo extends Vue {

    private startDate: string = moment(new Date).add(-3, 'M').format('YYYY-MM-DD')  // 過去三ヶ月がデフォルト
    private endDate: string = moment(new Date).format('YYYY-MM-DD')

}